(function () {
  angular.module("akitabox.ui.components.pinValueInput", [
    "akitabox.core.services.pinValue",
    "akitabox.core.utils",
  ]);
})();
